import React, { useState, useEffect } from 'react';
import { fetchSucursales } from '../../../controller/sucursalController'; // Importar función de API
import { Container, Table, Button } from 'react-bootstrap'; // Componentes Bootstrap
import { PencilSquare, Plus } from 'react-bootstrap-icons';
import { useNavigate } from 'react-router-dom';

function SucursalesView() {
  const [sucursales, setSucursales] = useState([]); // Estado de sucursales
  const [loading, setLoading] = useState(true); // Estado de carga
  const navigate = useNavigate(); // Hook para redirección

  // Llamar API al montar componente
  useEffect(() => {
    const getSucursales = async () => {
      try {
        const data = await fetchSucursales();
        setSucursales(data); // Actualizar estado
      } catch (error) {
        console.error('Error al obtener las sucursales:', error);
      } finally {
        setLoading(false);
      }
    };

    getSucursales();
  }, []);

  if (loading) {
    return <h1>Cargando sucursales...</h1>;
  }

  const handleEdit = (sucursal) => {
    navigate(`/sucursales/editSucursal`, { state: { sucursal } });
  };

  const handleCreate = () => {
    navigate(`/sucursales/createSucursal`);
  };

  return (
    <Container className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Sucursales</h1>
        <Button variant="primary" onClick={handleCreate}>
          <Plus className="me-2" /> Crear Sucursal
        </Button>
      </div>

      <Table striped bordered hover>
        <thead>
          <tr>
            <th>Nombre</th>
            <th>Dirección</th>
            <th>Número</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {sucursales.map((sucursal) => (
            <tr key={sucursal.id}>
              <td>{sucursal.name}</td>
              <td>{sucursal.address}</td>
              <td>{sucursal.phone_number || 'N/A'}</td>
              <td>
                <Button variant="light" size="sm" onClick={() => handleEdit(sucursal)}>
                  <PencilSquare color="blue" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
}

export default SucursalesView;
